import React, { Component } from 'react';

class Header extends Component {
    constructor(props) {
        super(props);

    }
    componentDidUpdate() {
        $('[data-toggle="tooltip"]').tooltip();
    }


    render() {
        const { cliente, cuenta, parametros, datosActualizados } = this.props;
        let iconoTarjeta = ""


        switch (cuenta.marcaId) {
            case 1: {
                iconoTarjeta = "image-visa-logo logoVisaHeader";
                break;
            }
            case 2: {
                iconoTarjeta = "image-cabal-logo logoCabalHeader";
                break;
            }
            case 3: {
                iconoTarjeta = "image-mastercard-logo-tab";
                break;
            }
        }

        let estadoAMostrar = "";
        let claseEstado = "";
        let cuit = "";
        let iconoTipoModificacion = parametros && parametros.SINOCONFIRMACIONMODIFCTA ? "icono-modif-pendiente" : "icono-modif-inmediato";
        let textoTooltip = parametros && parametros.SINOCONFIRMACIONMODIFCTA ? "Algunas modificaciones requieren confirmación para ser ejecutadas." : "Modificaciones inmediatas.";
        let iconoPersona = cliente.FisicaJuridica == "J" ? <div className="iconoPersonaJuridicaDiv"><div className="iconoPersonaJuridicaImg" ></div></div> : <span className="icon-ti-user-icon-persona-gris iconoPersonaCliente"></span>
        let documento = "";

        if (cliente) {
            if (cliente.NumeroDocumento)
                documento = cliente.NumeroDocumento.toString();
            else if (cliente.Documento)
                documento = cliente.Documento.toString();

            cuit = documento.includes("-") ? documento : cuit + documento.substring(0, 2) + "-" + documento.substring(2, ((documento.length) - 1)) + "-" + documento[documento.length - 1]
        }

        switch (cuenta.estadoId) {
            case 1:
                estadoAMostrar = "SOLICITADA"
                claseEstado = " etiquetaCelesteHeader"
                break;
            case 2:
                estadoAMostrar = "OPERATIVA"
                claseEstado = " etiquetaVerdeHeader"
                break;
            case 3:
                estadoAMostrar = "OPERATIVA"
                claseEstado = " etiquetaCelesteHeader"//" etiquetaVerdeHeader"
                break;
            case 4:
                estadoAMostrar = "INHABILITADA"
                claseEstado = " etiquetaCelesteHeader"
                break;
            case 5:
                estadoAMostrar = "EN PROC. DE BAJA"
                claseEstado = " etiquetaCelesteHeader"
                break;
            case 6:
                estadoAMostrar = "DADA DE BAJA"
                claseEstado = " etiquetaCelesteHeader"
                break;
            case 7:
                estadoAMostrar = "EN PROC.DE BAJA"
                claseEstado = " etiquetaCelesteHeader"
                break;
            case 8:
                estadoAMostrar = "RECHAZADA"
                claseEstado = " etiquetaCelesteHeader"
                break;

        }

        return (
            <div>

                <div className="CuentaSeleccionContainer">
                    <div className="headerDatosContainer">
                        <div className=" headerDatosTitulo">
                            <td className="modal-info-alta-individuo">Titular</td>
                        </div>
                        <div className="">
                            <td className="headerDatosCampo">{cliente.Nombre + " " + cliente.Apellido}</td>
                        </div>
                    </div>
                    <div className="modalDemandaBody headerDatosContainer">
                        <div className='height50pc'>
                            <div className="headerDatosTitulo left-separator">
                                <td className="modal-info-alta-individuo header-inner-col">Marca</td>
                            </div>
                            <div className="left-separator">
                                <td className="modal-info-alta-individuo header-inner-col"><label className={iconoTarjeta}></label></td>
                            </div>
                        </div>
                        <div className='height50pc'>
                            <div className="headerDatosTituloPadding left-separator">
                                <td className="modal-info-alta-individuo header-inner-col">Nro. de Cuenta</td>
                            </div>
                            <div className="left-separator">
                                <td className="headerDatosCampo header-inner-col">{cuenta.CuentaTarjetaNumero}</td>
                            </div>
                        </div>
                    </div>
                    <div className="modalDemandaBody">
                        <div className='height50pc'>
                            <div className="headerDatosTitulo left-separator">
                                <td className="modal-info-alta-individuo header-inner-col">Tipo de Cuenta</td>
                            </div>
                            <div className="left-separator">
                                <td className="headerDatosCampoDescCuenta header-inner-col">{cuenta.tipoCuentaEmpresDescricpion}</td>
                            </div>
                        </div>
                        <div className='height50pc'>
                            <div className="headerDatosTituloPadding left-separator">
                                <td className="modal-info-alta-individuo header-inner-col">Estado</td>
                            </div>
                            <div className="left-separator">
                                {estadoAMostrar == "EN PROC.DE BAJA" ?
                                    <td className="label-titulo header-inner-col"><label className={claseEstado + " CuentaSeleccionContainer"} style={{ height: "30px" }}>{estadoAMostrar}</label></td> :
                                    <td className="label-titulo header-inner-col"><label className={claseEstado + " CuentaSeleccionContainer"}>{estadoAMostrar}</label></td>
                                }
                            </div>
                        </div>
                    </div>

                </div>
                <div className="row bottom-separator">
                    <div className="col-md-12 right label-primary"></div>
                </div>
                <div className="row bottom-separator separadorHeader">
                    <div className="inlineListItem">
                        {iconoPersona}&nbsp;
                        {cliente.FisicaJuridica == "J" ? "CUIT " + cuit : cliente.Codigo + " " + cliente.Documento}
                    </div>
                    <div data-toggle="tooltip" key={"icon-modif " + (parametros && parametros.SINOCONFIRMACIONMODIFCTA ? "1" : "2")} data-title={textoTooltip} data-placement="left" className={iconoTipoModificacion + " item-pull-right"}></div>
                </div>
                <div className="row bottom-separator separadorHeader">
                    <div data-toggle="tooltip" key="datosActualizados" data-title={"Ultima fecha de procesamiento de los archivos de movimientos (2001, 3022 y 3052) de GP."} data-placement="left" className="datosActualizadosFecha">Datos Actualizados al {datosActualizados}</div>
                </div>
            </div>
        );
    }
}

export default Header;

